import {
  Component,
  OnInit,
  Input,
  ViewChild,
  AfterViewInit,
  OnChanges,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
  ViewEncapsulation,
  Inject,
  SimpleChanges,
  QueryList,
  ViewChildren,
  SecurityContext,
  DOCUMENT
} from '@angular/core';

import { Router, ActivatedRoute } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, Sort } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';
import { ProductMappingService } from '../../../../padu-reporting/product-mapping-view/product-mapping.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatPaginator } from '@angular/material/paginator';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { EditReportComponent } from '../../../../reports/edit-report/edit-report.component';
import { ReportsService } from '../../../../reports/reports.service';
import { DomSanitizer } from '@angular/platform-browser';
import { SharedAuthService } from '../../../../shared/shared.auth.service';
export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}
export interface TableFilterConfig {
  placeHolderText: string;
  labelText: string;
  filterCallBack: (event: any) => any;
  filterPredicate?: (item: any, filter: string) => boolean;
}

@Component({
    selector: 'app-table-data',
    templateUrl: './table-data.component.html',
    styleUrls: ['./table-data.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'))
        ])
    ],
    standalone: false
})
export class TableDataComponent implements OnInit, AfterViewInit, OnChanges {
  isSearchEnabled = false;
  olddatasource: any;
  constructor(
    private route: Router,
    private router: ActivatedRoute,
    private service: ProductMappingService,
    @Inject(DOCUMENT) private _document: HTMLDocument,
    public dialog: MatDialog,
    private reportsService: ReportsService,
    private sanitizer: DomSanitizer,
    private sharedAuthService: SharedAuthService
  ) {}
  searchField;
  @Input() capabilityModel;
  @Input() checked: boolean = false;
  public product_app_view = true;
  @Input() dataSource: MatTableDataSource<any> = new MatTableDataSource([]);
  @Input() columns: Array<{
    columnDef: string;
    header: string;
    width: string;
    type: string;
    spanCellStyle: () => object;
    display: string;
    textAlign: string;
    paddingRight: string;
    cellStyle: () => object;
    cell: () => object;
    marginLeft: string;
  }>;
  @Input() TABLE_CONFIG;
  @Input() pageSize;
  @Input() pageIndex: number = 0;
  @Input() tableHeaders: Array<any> = [];
  @Input() filterConfig: TableFilterConfig;
  /** Gates the "Edit Report Template / JSON" icon on the reports 'action' column. */
  @Input() hasReportAdminAccess: boolean = false;
  @Output() openFullReportEditorEvent: EventEmitter<any> = new EventEmitter();
  @Output() deleteFullReportEvent: EventEmitter<any> = new EventEmitter();
  @Input() searchConfig?: any;
  @Input() tableConfig: any;
  @Input() localFilterConfig: any;
  @Input() expandTable;
  @Input() capabilitySelected: any;
  @Input() isInfraTable :boolean = false;
  @Input() orgData: any;
  @ViewChild('pagination', { static: true, read: true }) DynamicPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatSort, { static: false }) DynamicSort: MatSort;
  @Output() rowClick = new EventEmitter<any>();
  @Output() cellClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() localFilterServerSidePageEvent: EventEmitter<any> = new EventEmitter();
  @Input() sortConfig: Sort;
  @Input() localFilter: boolean = false;
  displayedColumns: Array<string>;
  tableHeaderColumn: Array<string>;
  selection = new SelectionModel<PeriodicElement>(true, []);
  @Input() SelectAll = false;
  @Input() displaySelectAll = true;
  @Input() setStakeholderView = false;
  @Output() onCheckClick: EventEmitter<any> = new EventEmitter();
  @Output() onChildClick: EventEmitter<any> = new EventEmitter();
  allSelected: boolean = false;
  public dataReady = false;
  public oldlength: any;
  public isExpand: boolean = false;
  tooltipInfo = 'Benefits';
  decomColumn: any;
  plmColumn: any;
  model: string;
  @Input() hidecolumn = false;
  @Input() productView = '';
  @Input() initialTableData;
  @Input() FinalTableData;
  @Input() stackHolderColumns;
  finalTableData = [];
  @Input() togglecolumn: any = [];
  defaultData;
  filterList = [];
  filterListR: any;
  filValue = [];
  REPFilter = [];
  REPCategoryFilter = [];
  DSCFilter = [];
  TYPEFilter = [];
  Allfilter = [];
  assetIdFilter = [];
  assetNameFilter = [];
  assetOwnerFilter = [];
  assetTeamFilter = [];
  billingGroupsFilter = [];
  categoryNameFilter = [];
  writeAcess = JSON.parse(sessionStorage.getItem('isWriteAccess'));
  searchValue = '';
  selectedServiceInfraCategory: any[] = [];
  @Input() sharedSelectedCategories: any[] = []; // Shared selection from parent
  firstClickOnFilter = false;
  isCheckedShowAllColumn = true;
  selectedFilteredValue = {
    appName: ''
  };
  public selectedRowIndex: any = '';
  @Input() rowExpandable: any;
  tableTotalItems;
  @Output() paginationClickEvent: EventEmitter<any> = new EventEmitter();
  @Output() sortChangeEvent: EventEmitter<any> = new EventEmitter();
  prodInitial: any;
  prodFamilyInitial: any;
  productId: any;
  productFamilyId: any;
  expandedElement: any;
  tempOrgID = 0;
  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @Input() paduData;
  @ViewChildren(MatMenuTrigger) trigger: QueryList<MatMenuTrigger>;
  filterApplied: boolean = false;
  filterAssetIdApplied: boolean = false;
  filterAssetNameApplied: boolean = false;
  filterAssetOwnerApplied: boolean = false;
  filterAssetTeamApplied: boolean = false;
  filterApplicationNameApplied: boolean = false;
  filterApplicationIdApplied: boolean = false;
  filterApplicationPADUApplied: boolean = false;
  filterApplicationLifeCycleApplied: boolean = false;

  ClickIgnoreColumns = ['Request', 'static_columns', 'column1', 'MOM', 'Roster_Status'];
  @Output() datarefresh: EventEmitter<any> = new EventEmitter();
  previousSelection:Array<any> = [];
  searchFilterLists :Array<any> = [];
  @Output() editRecordEvent: EventEmitter<any> = new EventEmitter();
  @Output() updatePrimaryStatusEvent: EventEmitter<any> = new EventEmitter();
  @Input() isTableRefreshed: boolean = false;
  @Input() resetServiceInfraCategory: boolean = false;
  @Input() hideRowLines: boolean = false;
  @Output() onApplicationLinkClicked: EventEmitter<any> = new EventEmitter();

  // Keeps the same column view alive across refreshes so re-computed header content (e.g. totals) actually re-renders
  trackByColumnDef(index: number, column: any): string {
    return column?.columnDef ?? index;
  }

  // Duplicate columnDef values break both trackBy identity and Angular Material's own column registration
  private warnOnDuplicateColumnDefs(): void {
    if (!this.columns?.length) {
      return;
    }
    const seen = new Set<string>();
    const duplicates = new Set<string>();
    this.columns.forEach(column => {
      if (seen.has(column.columnDef)) {
        duplicates.add(column.columnDef);
      }
      seen.add(column.columnDef);
    });
    if (duplicates.size) {
      console.warn(`app-table-data: duplicate columnDef(s) detected: ${Array.from(duplicates).join(', ')}`);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.dataReady = false;
    if (changes['columns']) {
      this.warnOnDuplicateColumnDefs();
    }
    if (changes['capabilitySelected']) {
      this.handleCapabilitySelectionChange();
    }
    if(this.isInfraTable){
        this.olddatasource = [...this.dataSource.data];       
    }

    // Sync with shared selection state from parent
    if (changes['sharedSelectedCategories'] && this.sharedSelectedCategories) {
      this.selectedServiceInfraCategory = [...this.sharedSelectedCategories];
    }

    if (changes['resetServiceInfraCategory'] && this.resetServiceInfraCategory) {
      this.selectedServiceInfraCategory = [];
      console.log("entered",this.resetServiceInfraCategory);
    }

    if (this.dataSource && this.dataSource.data && this.dataSource.data.length) {
      this.processDataSourceChanges(changes);
      this.configureFilterPredicates();
      this.setTempOrgID();
      this.configurePaginationAndSorting();
      this.dataReady = true;
    } else {
      this.dataReady = false;
    }

    if (this.isTableRefreshed) {
      this.selection.clear();
    }

    if (this.checked) this.viewChange(this.checked);
    this.removeLinkToTechPadu();
  }

  private handleCapabilitySelectionChange(): void {
    if (!this.capabilitySelected || !this.capabilitySelected.type || !this.capabilitySelected.orgIDS) {
      return;
    }

    let valueChange = false;
    this.dataSource.data.forEach(row => {
      const selectionChanged = this.processRowSelection(row);
      if (selectionChanged) {
        valueChange = true;
      }
    });

    if (valueChange) {
      this.onCheckClick.emit({ check: false, data: this.selection.selected, tempOrgID: this.tempOrgID });
    }
  }

  private processRowSelection(row: any): boolean {
    if (this.capabilitySelected.type === 'allDeSelected') {
      this.selection.clear();
      return true;
    }

    const hasOrgIDS = this.capabilitySelected.orgIDS.length > 0;
    const includesOrgID = this.capabilitySelected.orgIDS.includes(row.tempOrgID);

    if (this.capabilitySelected.type === 'allSelected' && hasOrgIDS && includesOrgID) {
      this.selection.select(row);
      return true;
    }

    if (hasOrgIDS && includesOrgID) {
      if (this.capabilitySelected.type === 'selected') {
        this.selection.select(row);
      } else {
        this.selection.deselect(row);
      }
      return true;
    }

    return false;
  }

  private processDataSourceChanges(changes: SimpleChanges): void {
    if (
      changes.dataSource &&
      changes.dataSource.currentValue &&
      changes.dataSource.previousValue &&
      changes.dataSource.currentValue.filteredData != changes.dataSource.previousValue.filteredData
    ) {
      console.log('Empty Decleartion');
    }
  }

  private configureFilterPredicates(): void {
    if (this.searchConfig && this.searchConfig.filterPredicate) {
      this.dataSource.filterPredicate = this.searchConfig.filterPredicate;
    }
    if (this.filterConfig && this.filterConfig.filterPredicate) {
      this.dataSource.filterPredicate = this.filterConfig.filterPredicate;
    }
  }

  private setTempOrgID(): void {
    if (this.dataSource.data[0].tempOrgID) {
      this.tempOrgID = this.dataSource.data[0].tempOrgID;
    }
  }

  private configurePaginationAndSorting(): void {
    if (this.tableConfig && this.tableConfig.serverSidePagination) {
      this.configureServerSidePagination();
    } else {
      this.configureClientSidePagination();
    }
  }

  private configureServerSidePagination(): void {
    this.tableTotalItems = this.tableConfig.totalItems;
    this.dataSource.paginator = this.DynamicPaginator;

    if (this.sortConfig && this.DynamicSort) {
      this.DynamicSort.active = this.sortConfig.active;
      this.DynamicSort.direction = this.sortConfig.direction;
      this.dataSource.sort = this.DynamicSort;
    }
  }

  private configureClientSidePagination(): void {
    this.dataSource.paginator = this.paginator.toArray()[0];
    this.dataSource.sort = this.sort;
    
    if (this.sortConfig && this.sort) {
      this.sort.active = this.sortConfig.active || '';
      this.sort.direction = this.sortConfig.direction;
      this.sort.sortChange.emit(this.sortConfig);
    }
  }


  removeLinkToTechPadu() {
    const element = this._document.querySelectorAll('.link-click');
    if (element && element.length > 0) {
      element.forEach(ele => {
        const childNode = ele.getElementsByClassName('no-link');
        if (childNode && childNode.length > 0) {
          ele.classList.replace('link-click', 'no-link');
        }
      });
    }
  }
  getRecord(row, col) {
    const obj = { row, col };
    this.rowClick.emit(obj);
  }
  getcellRecord(row, col) {
      const obj = { row, col };
      this.cellClick.emit(obj);
  }

  getServiceCategoryList(row, col){
      this.resetServiceInfraCategory=false;
      if (!row && col && col.categoryType) {
        // Check if header is already selected
        const headerIndex = this.selectedServiceInfraCategory.findIndex(item => 
          item.row === undefined && item.col && item.col.categoryType === col.categoryType
        );
        
        if (headerIndex > -1) {
          this.selectedServiceInfraCategory.splice(headerIndex, 1);
        } else {
          this.selectedServiceInfraCategory = this.selectedServiceInfraCategory.filter(item => 
            !(item.row && item.col && item.col.categoryType === col.categoryType)
          );
          this.selectedServiceInfraCategory.push({ row: undefined, col });
        }
      } else {
        const index = this.selectedServiceInfraCategory.findIndex(item => item.row === row);
        
        if (index > -1) {
          this.selectedServiceInfraCategory.splice(index, 1);
        } 
        else {
          this.selectedServiceInfraCategory = this.selectedServiceInfraCategory.filter(item => 
            !(item.row === undefined && item.col && item.col.categoryType === col.categoryType)
          );
          this.selectedServiceInfraCategory.push({ row, col });
        }
      }
      this.cellClick.emit(this.selectedServiceInfraCategory);
  }

  isServiceInfraCategorySelected(element: any): boolean {
    return this.selectedServiceInfraCategory.some(item => {
      if (typeof element === 'object' && element.columnDef === 'Service_Infra_Category' && element.categoryType) {
        return item.row === undefined && item.col && item.col.categoryType === element.categoryType;
      }
      if (item.row === element) {
        return true;
      }
      return false;
    });
  }
  ngOnInit() {
    this.allSelected = false;
    this.displayedColumns = this.columns.map(element => element.columnDef);
    this.tableHeaderColumn = this.tableHeaders.map(item => item.def);
    this.router.queryParams.subscribe(details => {
      this.model = details.model || '';
    });
    this.defaultData = this.dataSource && this.dataSource.data;
    this.prodInitial = this.router.snapshot.queryParamMap.get('product');
    this.prodFamilyInitial = this.router.snapshot.queryParamMap.get('product_family');
    this.productId = this.router.snapshot.queryParamMap.get('product_id');
    this.productFamilyId = this.router.snapshot.queryParamMap.get('family_id');
    this.olddatasource = this.dataSource.data;
  }
  ngDoCheck() {
    this.removeLinkToTechPadu();
  }
  ngAfterViewInit() {
    if (this.dataSource && this.dataSource.data.length) {
      if (this.filterConfig && this.filterConfig.filterPredicate) {
        this.dataSource.filterPredicate = this.filterConfig.filterPredicate;
      }

      if (this.tableConfig && this.tableConfig.serverSidePagination) {
        this.tableTotalItems = this.tableConfig.totalItems;
        this.dataSource.paginator = this.DynamicPaginator;
        if (this.sortConfig && this.DynamicSort) {
          this.DynamicSort.active = this.sortConfig.active || '';
          this.DynamicSort.direction = this.sortConfig.direction;
        }

        this.dataSource.sort = this.DynamicSort;
      } else {
        this.dataSource.paginator = this.paginator.toArray()[0];
        this.dataSource.sort = this.sort;
      }

      if (this.tableConfig && this.tableConfig.searchString) {
        this.searchField = this.tableConfig.searchString;
      }
    }
    if (this.checked) {
      this.viewChange(this.checked);
    }
  }

  evaluateFunction(column, element) {
    let output = {};
    if (column.cellStyle) {
      output = column.cellStyle(element);
    }

    if (column.type === 'number') {
      output['text-align-right'] = true;
    }
    if (column.type === 'textnumber') {
      output['text-align-center'] = true;
    }
    if (column.type === 'html') {
      output['text-align-left'] = true;
    }
    return output;
  }


  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    this.onChildClick.emit({ childCheck: numSelected === numRows, data: [] });
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
      this.onCheckClick.emit({ check: false, data: [], tempOrgID: this.tempOrgID });
    } else {
      this.dataSource.data.forEach(row => this.selection.select(row));
      this.onCheckClick.emit({ check: true, data: this.selection.selected, tempOrgID: this.tempOrgID });
    }
  }

  selecttoggle() {
    if (this.selection.selected.length > 0) {
      this.onCheckClick.emit({ check: true, data: this.selection.selected, tempOrgID: this.tempOrgID });
    } else {
      this.onCheckClick.emit({ check: false, data: [], tempOrgID: this.tempOrgID });
    }
  }
  onClickClearSearchField() {
    this.searchField = '';
    if (this.getTableClass()) {
      this.filterConfig.filterCallBack('');
    }
  }

  redirectToAppView(element) {
    const { app_id } = element;
    this.route.navigate(['application-insights'], { queryParams: { askId: app_id } });
  }

  getTooltipInfo(column, element) {
    if (column.description) {
      if (column.description.value) {
        switch (column.columnDef) {
          case 'product':
            if (element.productDescription) {
              return `${element.productDescription || 'No Description Available'}`;
            } else {
              return 'No Description Available';
            }

          case 'product_family':
            if (element.productFamilyDescription) {
              return `${element.productFamilyDescription || 'No Description Available'}`;
            } else {
              return 'No Description Available';
            }

          case 'current':
            return `Transition 1 : ${element.Transition1},
                    Transition 2 : ${element.Transition2},
                    Transition 3 : ${element.Transition3},
                    Transition 4 : ${element.Transition4},
                    Transition 5 : ${element.Transition5},
                    Transition 6 : ${element.Transition6}`;

          default:
            return `${column.description.name}: ${column.cell(element)}`;
        }
      } else {
        if (typeof column.description == 'function') {
          const descResponse = column.description(element);
          if (descResponse) {
            return `${descResponse}`;
          }
        } else {
          return `${column.description.name}`;
        }
      }
    }
  }
  public viewChange(value) {
    if (value) {
      this.isCheckedShowAllColumn = false;
      this.product_app_view = false;
      const unique = (arr, props = []) => [
        ...new Map(arr.map(entry => [props.map(k => entry[k]).join('|'), entry])).values()
      ];
      const newArr = unique(this.dataSource.data, [
        'product_family',
        'product',
        'productManager',
        'productOwner',
        'deliveryOwner'
      ]);
      this.dataSource.data = newArr;
      this.defaultData = newArr;
      this.columns.forEach(element => {
        if (element.display === 'none') {
          this.togglecolumn.push(element.columnDef);
        }
        delete element.display;
        if (!this.stackHolderColumns.includes(element.columnDef)) {
          element.display = 'none';
        }
      });
    } else {
      this.isCheckedShowAllColumn = true;
      this.columns.forEach(element => {
        delete element.display;
        if (this.togglecolumn.includes(element.columnDef)) {
          element.display = 'none';
        }
      });
      if (this.productView === 'product_view') {
        this.dataSource.data = this.FinalTableData;
        this.defaultData = this.initialTableData;
      }
    }
  }

  checkEditFeasibility(column) {
    if (column.columnDef === 'action') {
      return false;
    } else if (column.columnDef === 'action-edit') {
      return true;
    } else {
      return false;
    }
  }

  checkDeleteRow(col) {
    if (col.columnDef === 'deleterow') return true;
  }

  filterDropdown(column) {
    let result;
    let result1;
    let result2;
    let result3;
    let result4;
    let result5;
    switch (column.columnDef) {
      case 'app_id':
        result = this.localFilterConfig.filter.filter(d => d.filterName === 'app_id');
        this.filterList = result[0].filterValue.map(i => ({ name: i.app_id, selected: false }));

        break;

      case 'application':
        result1 = this.localFilterConfig.filter.filter(d => d.filterName === 'application');
        this.filterList = result1[0].filterValue.map(i => ({ name: i.app_name, id: i.app_id, selected: false }));
        break;

      case 'lob':
        result2 = this.localFilterConfig.filter.filter(d => d.filterName === 'lob');
        this.filterList = result2[0].filterValue.map(i => ({ name: i, selected: false }));
        break;

      case 'product_family':
        result3 = this.localFilterConfig.filter.filter(d => d.filterName === 'product_family');
        this.filterList = result3[0].filterValue.map(i => ({ name: i.product_family, selected: false }));
        break;

      case 'product':
        result4 = this.localFilterConfig.filter.filter(d => d.filterName === 'product');
        this.filterList = result4[0].filterValue.map(i => ({ name: i.product, selected: false }));
        break;

      case 'organization':
        result5 = this.localFilterConfig.filter.filter(d => d.filterName === 'organization');
        this.filterList = result5[0].filterValue.map(i => ({ name: i, selected: false }));
        break;
    }
    return true;
  }

  applyLocalFilter(list, column) {
    const obj = {
      list: list,
      column: column,
      type: 'apply'
    };
    this.localFilterServerSidePageEvent.emit(obj);
  }

  clearLocalFilter(list, column) {
    this.previousSelection = [];
    const obj = {
      list: list,
      column: column,
      type: 'clear'
    };
    this.localFilterServerSidePageEvent.emit(obj);
  }

  checkLocalFilerValid(col) {
    if (this.localFilterConfig && this.localFilterConfig.localFilter) {
      switch (col) {
        case 'action':
        case 'productManager':
        case 'productOwner':
        case 'deliveryOwner':
          return false;

        case 'app_id':
        case 'application':
        case 'lob':
        case 'product_family':
        case 'product':
        case 'organization':
          return true;
      }
    } else {
      return false;
    }
  }

  valueSearchSave(val, column) {
    switch (column.columnDef) {
      case 'application':
        this.selectedFilteredValue.appName = val;
    }
  }
  filterLists: any = [];

  filterDropdownA(column) {
    this.searchValue = '';
    if (this.Allfilter.length == 0) {
      if (column.columnDef == 'assetId') {
        this.filterListR = this.olddatasource.map(item => {
          return item.assetId;
        });
        this.filValue = this.assetIdFilter;
        this.trigger.toArray()[0].openMenu();
      } else if (column.columnDef == 'assetName') {
        this.filterListR = this.olddatasource.map(item => {
          return item.assetName;
        });
        this.filValue = this.assetNameFilter;
        this.trigger.toArray()[1].openMenu();
      } else if (column.columnDef == 'owner') {
        this.filterListR = this.olddatasource.map(item => {
          return item.owner;
        });
        this.filValue = this.assetOwnerFilter;
        this.trigger.toArray()[2].openMenu();
      } else if (column.columnDef == 'ownerAssetTeam') {
        this.filterListR = this.olddatasource.map(item => {
          return item.ownerAssetTeam;
        });
        this.filValue = this.assetTeamFilter;
        this.trigger.toArray()[3].openMenu();
      }
      this.filterListR = new Set([...this.filterListR]);
      this.filterLists = this.filterListR;
    } else {
      if (column.columnDef == 'assetId') {
        this.filterListR = this.dataSource.data.map(item => {
          return item.assetId;
        });
        this.filValue = this.assetIdFilter;
        this.trigger.toArray()[0].openMenu();
      } else if (column.columnDef == 'assetName') {
        this.filterListR = this.dataSource.data.map(item => {
          return item.assetName;
        });
        this.filValue = this.assetNameFilter;
        this.trigger.toArray()[1].openMenu();
      } else if (column.columnDef == 'owner') {
        this.filterListR = this.dataSource.data.map(item => {
          return item.owner;
        });
        this.filValue = this.assetOwnerFilter;
        this.trigger.toArray()[2].openMenu();
      } else if (column.columnDef == 'ownerAssetTeam') {
        this.filterListR = this.dataSource.data.map(item => {
          return item.ownerAssetTeam;
        });
        this.filValue = this.assetTeamFilter;
        this.trigger.toArray()[3].openMenu();
      }
      this.filterListR = new Set([...this.filterListR]);
      this.filterLists = this.filterListR;
    }
  }
  filterDropdownR(column) {
    this.searchValue = '';
    if (this.Allfilter.length == 0) {
      if (column.header == 'Report') {
        this.filterListR = this.olddatasource.map(item => {
          return item.Report;
        });
        this.filValue = this.REPFilter;
        this.trigger.toArray()[0].openMenu();
      }
      if (column.header == 'Report Category') {
        this.filterListR = this.olddatasource.map(item => {
          return item.Category;
        });
        this.filValue = this.REPCategoryFilter;
        this.trigger.toArray()[1].openMenu();
      }
      if (column.header == 'Description') {
        this.filterListR = this.olddatasource.map(item => {
          return item.Description;
        });
        this.filValue = this.DSCFilter;
        this.trigger.toArray()[2].openMenu();
      }
      if (column.header == 'Type') {
        this.filterListR = this.olddatasource.map(item => {
          return item.Report_Type;
        });
        this.filValue = this.TYPEFilter;
        this.trigger.toArray()[3].openMenu();
      }

      this.filterListR = new Set([...this.filterListR]);
      this.filterLists = this.filterListR;
    } else {
      if (column.header == 'Report') {
        this.filterListR = this.dataSource.data.map(item => {
          return item.Report;
        });
        this.filValue = this.REPFilter;
        this.trigger.toArray()[0].openMenu();
      }
      if (column.header == 'Report Category') {
        this.filterListR = this.dataSource.data.map(item => {
          return item.Category;
        });
        this.filValue = this.REPCategoryFilter;
        this.trigger.toArray()[1].openMenu();
      }
      if (column.header == 'Description') {
        this.filterListR = this.dataSource.data.map(item => {
          return item.Description;
        });
        this.filValue = this.DSCFilter;
        this.trigger.toArray()[2].openMenu();
      }
      if (column.header == 'Type') {
        this.filterListR = this.dataSource.data.map(item => {
          return item.Report_Type;
        });
        this.filValue = this.TYPEFilter;
        this.trigger.toArray()[3].openMenu();
      }
      this.filterListR = new Set([...this.filterListR]);
      this.filterLists = this.filterListR;
    }
  }
  applyLocalFilterR() {
    let filterdata = this.olddatasource;
    this.Allfilter.forEach(filter => {
      if (filter.value.length > 0) {
        filterdata = this.applyColumnFilter(filterdata, filter);
      } else {
        this.updateFilterState(filter.column, false);
      }
    });

    this.handleEmptyFilters();
    this.closeAllMenuTriggers();
  }

  private applyColumnFilter(filterdata: any[], filter: any): any[] {
    const config = this.getFilterConfiguration(filter.column);
    if (!config) {
      return filterdata;
    }

    const filteredData = filterdata.filter(item => 
      filter.value.some(value => value === item[config.dataProperty])
    );

    this.updateDataSourceAndFilters(filteredData, config, filter.column);
    return filteredData;
  }

  private getFilterConfiguration(column: string): any {
    const configurations = {
      'Report': { dataProperty: 'Report', triggerIndex: 0 },
      'Report Category': { dataProperty: 'Category', triggerIndex: 1 },
      'Description': { dataProperty: 'Description', triggerIndex: 2 },
      'Type': { dataProperty: 'Report_Type', triggerIndex: 3 },
      'ApplicationID': { dataProperty: 'ApplicationID', triggerIndex: 0, hasFilterState: true },
      'Application ID': { dataProperty: 'app_id', triggerIndex: 0, hasFilterState: true },
      'ApplicationName': { dataProperty: 'ApplicationName', triggerIndex: 1, hasFilterState: true },
      'Application Name': { dataProperty: 'app_name', triggerIndex: 1, hasFilterState: true },
      'Capability PADU': { dataProperty: 'CapabilityPADU', triggerIndex: 2 },
      'Application PADU': { dataProperty: 'ApplicationPADU', triggerIndex: 2, hasFilterState: true },
      'Service_Description': { dataProperty: 'Service_Description', triggerIndex:this.isInfraTable?1: 2, hasFilterState: true },
      'Billing_Groups': { dataProperty: 'Billing_Groups', triggerIndex: 0, hasFilterState: true },
       'CategoryName': { dataProperty: 'CategoryName', triggerIndex:this.isInfraTable?0: 1, hasFilterState: true },
      'server': { dataProperty: 'CS_SERVICE_VIRTUAL', triggerIndex: 0, hasFilterState: true },
      'assetId': { dataProperty: 'assetId', triggerIndex: 0, assetFilter: 'filterAssetIdApplied' },
      'assetName': { dataProperty: 'assetName', triggerIndex: 1, assetFilter: 'filterAssetNameApplied' },
      'owner': { dataProperty: 'owner', triggerIndex: 2, assetFilter: 'filterAssetOwnerApplied' },
      'ownerAssetTeam': { dataProperty: 'ownerAssetTeam', triggerIndex: 3, assetFilter: 'filterAssetTeamApplied' },
      'Application Life Cycle': { dataProperty: 'app_lifecycle_status', triggerIndex: 2, hasFilterState: true }
    };
    return configurations[column];
  }

  private updateDataSourceAndFilters(filteredData: any[], config: any, column: string): void {
    this.filterListR = filteredData.map(item => item[config.dataProperty]);
    this.updateDataSource(filteredData);
    this.updateFilterState(column, true);
    this.trigger.toArray()[config.triggerIndex].closeMenu();
  }

  private updateDataSource(data: any[]): void {
    this.dataSource = new MatTableDataSource(data);
    this.dataSource.paginator = this.paginator.toArray()[0];
    this.dataSource.sort = this.sort;
  }

  private updateFilterState(column: string, applied: boolean): void {
    const stateMap = {
      'ApplicationID': 'filterApplicationIdApplied',
      'ApplicationName': 'filterApplicationNameApplied', 
      'Application PADU': 'filterApplicationPADUApplied',
      'assetId': 'filterAssetIdApplied',
      'assetName': 'filterAssetNameApplied',
      'owner': 'filterAssetOwnerApplied',
      'ownerAssetTeam': 'filterAssetTeamApplied',
      'Application ID': 'filterApplicationIdApplied',
      'Application Name': 'filterApplicationNameApplied',
      'Application Life Cycle': 'filterApplicationLifeCycleApplied'
    };

    if (stateMap[column]) {
      this[stateMap[column]] = applied;
    }

    if (['Application ID', 'ApplicationID', 'Application Name', 'ApplicationName', 'Application PADU', 'Service_Description','Billing_Groups', 'CategoryName', 'server', 'Application Life Cycle'].includes(column)) {
      this.filterApplied = applied;
    }
  }

  private handleEmptyFilters(): void {
    if (this.Allfilter.length === 0) {
      this.updateDataSource(this.olddatasource);
      this.resetAllFilterStates();
    }
  }

  private resetAllFilterStates(): void {
    this.filterApplied = false;
    this.filterAssetIdApplied = false;
    this.filterAssetNameApplied = false;
    this.filterAssetOwnerApplied = false;
    this.filterAssetTeamApplied = false;
    this.filterApplicationIdApplied = false;
    this.filterApplicationNameApplied = false;
    this.filterApplicationPADUApplied = false;
    this.filterApplicationLifeCycleApplied = false;
  }

  private closeAllMenuTriggers(): void {
    for (let i = 0; i < 4; i++) {
      const trigger = this.trigger.toArray()[i];
      if (trigger) {
        trigger.closeMenu();
      }
    }
  }

  clearLocalFilterR(column) {
    this.trigger.toArray()[0].closeMenu();
    if (this.trigger.toArray()[1]) {
      this.trigger.toArray()[1].closeMenu();
    }
    if (this.trigger.toArray()[2]) {
      this.trigger.toArray()[2].closeMenu();
    }
    if (this.trigger.toArray()[3]) {
      this.trigger.toArray()[3].closeMenu();
    }

    if (column.header == 'Report') {
      this.REPFilter = [];
      this.Allfilter.forEach((a, i) => {
        if (a.column == 'Report') this.Allfilter.splice(i, 1);
      });
    } else if (column.header == 'Report Category') {
      this.REPCategoryFilter = [];
      this.Allfilter.forEach((a, i) => {
        if (a.column == 'Report Category') this.Allfilter.splice(i, 1);
      });
    } else if (column.header == 'Description') {
      this.DSCFilter = [];
      this.Allfilter.forEach((a, i) => {
        if (a.column == 'Description') this.Allfilter.splice(i, 1);
      });
    } else if (column.header == 'Type') {
      this.TYPEFilter = [];
      this.Allfilter.forEach((a, i) => {
        if (a.column == 'Type') this.Allfilter.splice(i, 1);
      });
    } else if (column.header == 'ApplicationID') {
      this.REPFilter = [];
      this.Allfilter.forEach((a, i) => {
        if (a.column == 'ApplicationID') this.Allfilter.splice(i, 1);
      });
      this.filterApplicationIdApplied = false;
    } else if (column.header == 'ApplicationName') {
      this.DSCFilter = [];
      this.Allfilter.forEach((a, i) => {
        if (a.column == 'ApplicationName') this.Allfilter.splice(i, 1);
      });
      this.filterApplicationNameApplied = false;
    } else if (column.header == 'Application ID') {
      this.REPFilter = [];
      this.Allfilter.forEach((a, i) => {
        if (a.column == 'Application ID') this.Allfilter.splice(i, 1);
      });
      this.filterApplicationIdApplied = false;
    } else if (column.header == 'Application Name') {
      this.DSCFilter = [];
      this.Allfilter.forEach((a, i) => {
        if (a.column == 'Application Name') this.Allfilter.splice(i, 1);
      });
      this.filterApplicationNameApplied = false;
    } else if (column.header == 'Capability PADU') {
      this.TYPEFilter = [];
      this.Allfilter.forEach((a, i) => {
        if (a.column == 'Capability PADU') this.Allfilter.splice(i, 1);
      });
    } else if (column.header == 'Application PADU') {
      this.TYPEFilter = [];
      this.Allfilter.forEach((a, i) => {
        if (a.column == 'Application PADU') this.Allfilter.splice(i, 1);
      });
      this.filterApplicationPADUApplied = false;
    } else if (column.header == 'Application Life Cycle') {
      this.TYPEFilter = [];
      this.Allfilter.forEach((a, i) => {
        if (a.column == 'Application Life Cycle') this.Allfilter.splice(i, 1);
      });
      this.filterApplicationLifeCycleApplied = false;
    } else if (column.header == 'SERVICE') {
      this.TYPEFilter = [];
      this.Allfilter.forEach((a, i) => {
        if (a.column == 'Service_Description') this.Allfilter.splice(i, 1);
      });
      this.filterApplied = false;
    } else if (column.header == 'Billing Group') {
      this.billingGroupsFilter = [];
      this.Allfilter.forEach((a, i) => {
        if (a.column == 'Billing_Groups') this.Allfilter.splice(i, 1);
      });
      this.filterApplied = false;
    } else if (column.header == 'Category') {
      this.categoryNameFilter = [];
      this.Allfilter.forEach((a, i) => {
        if (a.column == 'CategoryName') this.Allfilter.splice(i, 1);
      });
      this.filterApplied = false;
    } else if (column.header == 'Server') {
      this.TYPEFilter = [];
      this.Allfilter.forEach((a, i) => {
        if (a.column == 'server') this.Allfilter.splice(i, 1);
      });
      this.filterApplied = false;
    } else if (column.columnDef == 'assetId') {
      this.assetIdFilter = [];
      this.Allfilter.forEach((a, i) => {
        if (a.column == 'assetId') this.Allfilter.splice(i, 1);
      });
      this.filterAssetIdApplied = false;
    } else if (column.columnDef == 'assetName') {
      this.assetNameFilter = [];
      this.Allfilter.forEach((a, i) => {
        if (a.column == 'assetName') this.Allfilter.splice(i, 1);
      });
      this.filterAssetNameApplied = false;
    } else if (column.columnDef == 'owner') {
      this.assetOwnerFilter = [];
      this.Allfilter.forEach((a, i) => {
        if (a.column == 'owner') this.Allfilter.splice(i, 1);
      });
      this.filterAssetOwnerApplied = false;
    } else if (column.columnDef == 'ownerAssetTeam') {
      this.assetTeamFilter = [];
      this.Allfilter.forEach((a, i) => {
        if (a.column == 'ownerAssetTeam') this.Allfilter.splice(i, 1);
      });
      this.filterAssetTeamApplied = false;
    }
    this.applyLocalFilterR();
  }
  selectionChangeR(event, column) {
    const columnConfig = this.getSelectionChangeConfiguration(column);
    if (!columnConfig) {
      return;
    }

    this.removeExistingFilter(columnConfig.filterColumn);
    const newevent = this.checkPrevious(event, columnConfig.filterArray);
    this.updateFilterBasedOnSelection(newevent, columnConfig);
    this.openMenuTrigger(columnConfig.triggerIndex);
  }

  private getSelectionChangeConfiguration(column: any): any {
    const headerConfigs = {
      'Report': { filterColumn: 'Report', filterArray: this.REPFilter, arrayProperty: 'REPFilter', triggerIndex: 0 },
      'Report Category': { filterColumn: 'Report Category', filterArray: this.REPCategoryFilter, arrayProperty: 'REPCategoryFilter', triggerIndex: 1 },
      'Description': { filterColumn: 'Description', filterArray: this.DSCFilter, arrayProperty: 'DSCFilter', triggerIndex: 2 },
      'Type': { filterColumn: 'Type', filterArray: this.TYPEFilter, arrayProperty: 'TYPEFilter', triggerIndex: 3 },
      'ApplicationID': { filterColumn: 'ApplicationID', filterArray: this.REPFilter, arrayProperty: 'REPFilter', triggerIndex: 0 },
      'Application ID': { filterColumn: 'Application ID', filterArray: this.REPFilter, arrayProperty: 'REPFilter', triggerIndex: 0 },
      'ApplicationName': { filterColumn: 'ApplicationName', filterArray: this.DSCFilter, arrayProperty: 'DSCFilter', triggerIndex: 1 },
      'Application Name': { filterColumn: 'Application Name', filterArray: this.DSCFilter, arrayProperty: 'DSCFilter', triggerIndex: 1 },
      'Capability PADU': { filterColumn: 'Capability PADU', filterArray: this.TYPEFilter, arrayProperty: 'TYPEFilter', triggerIndex: 2 },
      'Application PADU': { filterColumn: 'Application PADU', filterArray: this.TYPEFilter, arrayProperty: 'TYPEFilter', triggerIndex: 2 },
      'Application Life Cycle': { filterColumn: 'Application Life Cycle', filterArray: this.TYPEFilter, arrayProperty: 'TYPEFilter', triggerIndex: 2 },
      'SERVICE': { filterColumn: 'Service_Description', filterArray: this.TYPEFilter, arrayProperty: 'TYPEFilter', triggerIndex: this.isInfraTable? 1:0 },
      'Billing Group': { filterColumn: 'Billing_Groups', filterArray: this.billingGroupsFilter, arrayProperty: 'billingGroupsFilter', triggerIndex: 0 },
      'Category': { filterColumn: 'CategoryName', filterArray: this.categoryNameFilter, arrayProperty: 'categoryNameFilter', triggerIndex: this.isInfraTable ? 0: 1 },
      'Server': { filterColumn: 'server', filterArray: this.TYPEFilter, arrayProperty: 'TYPEFilter', triggerIndex: 0 }
    };

    const columnDefConfigs = {
      'assetId': { filterColumn: 'assetId', filterArray: this.assetIdFilter, arrayProperty: 'assetIdFilter', triggerIndex: 0 },
      'assetName': { filterColumn: 'assetName', filterArray: this.assetNameFilter, arrayProperty: 'assetNameFilter', triggerIndex: 1 },
      'owner': { filterColumn: 'owner', filterArray: this.assetOwnerFilter, arrayProperty: 'assetOwnerFilter', triggerIndex: 2 },
      'ownerAssetTeam': { filterColumn: 'ownerAssetTeam', filterArray: this.assetTeamFilter, arrayProperty: 'assetTeamFilter', triggerIndex: 3 }
    };

    if (column.header && headerConfigs[column.header]) {
      return headerConfigs[column.header];
    }
    if (column.columnDef && columnDefConfigs[column.columnDef]) {
      return columnDefConfigs[column.columnDef];
    }
    return null;
  }

  private removeExistingFilter(filterColumn: string): void {
    this.Allfilter.forEach((a, i) => {
      if (a.column === filterColumn) {
        this.Allfilter.splice(i, 1);
      }
    });
  }

  private updateFilterBasedOnSelection(newevent: any, config: any): void {
    if (newevent.source._value.length > 0) {
      this[config.arrayProperty] = newevent.source._value;
      this.Allfilter.push({ column: config.filterColumn, value: newevent.source._value });
    } else {
      this[config.arrayProperty] = [];
    }
  }

  private openMenuTrigger(triggerIndex: number): void {
    const trigger = this.trigger.toArray()[triggerIndex];
    if (trigger) {
      trigger.openMenu();
    }
  }
  clearallFilter() {
    if (this.trigger.toArray()[0]) {
      this.trigger.toArray()[0].closeMenu();
    }
    if (this.trigger.toArray()[1]) {
      this.trigger.toArray()[1].closeMenu();
    }
    if (this.trigger.toArray()[2]) {
      this.trigger.toArray()[2].closeMenu();
    }
    if (this.trigger.toArray()[3]) {
      this.trigger.toArray()[3].closeMenu();
    }
    this.REPFilter = [];
    this.REPCategoryFilter = [];
    this.DSCFilter = [];
    this.TYPEFilter = [];
    this.assetIdFilter = [];
    this.assetNameFilter = [];
    this.assetOwnerFilter = [];
    this.assetTeamFilter = [];
    this.billingGroupsFilter = [];
    this.categoryNameFilter = [];
    this.Allfilter = [];
    this.dataSource = new MatTableDataSource(this.olddatasource);
    this.dataSource.paginator = this.paginator.toArray()[0];
    this.dataSource.sort = this.sort;
    this.filterApplied = false;
    this.filterAssetIdApplied = false;
    this.filterAssetNameApplied = false;
    this.filterAssetOwnerApplied = false;
    this.filterAssetTeamApplied = false;
    this.filterApplicationIdApplied = false;
    this.filterApplicationNameApplied = false;
    this.filterApplicationPADUApplied = false;
    this.filterApplicationLifeCycleApplied = false;
  }
  searchR(query: string) {
    this.searchFilterLists = this.filterLists;
    const result = this.selectR(query);
    this.searchFilterLists = result;
  }
  selectR(query: string): string[] {
    const result: string[] = [];
    for (const a of this.filterListR) {
      if (a.toLowerCase().indexOf(query.toLowerCase()) > -1) {
        result.push(a);
      }
    }
    return result;
  }
  navigateUrl(element: any) {
    if(element.EMbed == "Yes")
    this.route.navigate(['/reports'], { queryParams:{Report: element.Report }});
    else if (element.Report_Type == "Large Extracts"){
      this.navigateUrlForLargeExtracts(element);
    }else
    window.open(element.Report_Link, '_blank');
  }

  //getting selected secure group from local storage
  getSelectedSecureGroup() {
    const groups = JSON.parse(sessionStorage.getItem('secureGroups'));
    return Object.keys(groups).filter(item => groups[item] === 'Yes');
  }

  //check for navigation based on secure group
  navigateUrlForLargeExtracts(element: any) {
    const reportSecure = this.checkSecureGroup(element);
    if (reportSecure.length > 0) {
      this.navigateUrlForLargeExtractReport(element);
    } else {
      this.handleNavigationForDocumentation(element);
    }
  }

  //check for access based on secure group
  checkSecureGroup(Report: any) {
    const selectedSecure = this.getSelectedSecureGroup();
    if (Report.Access_Restricted === 'Yes' && Report['Secure'] === 'Yes') {
      let reportSecure = Report['Secure_Check'].split(',');
      reportSecure = reportSecure.filter((item: any) => selectedSecure.includes(item));
      return reportSecure;
    }
  }

  //navigate to large extract report
  navigateUrlForLargeExtractReport(Report: any) {
    this.route.navigateByUrl('reports?Report=' + Report.Report);
  }

  //navigate to documentation
  handleNavigationForDocumentation(Report: any) {
    if (Report.Access_Restriction_link)
      window.open(Report.Access_Restriction_link, '_blank');
    else if (Report.Documentation)
      window.open(Report.Documentation, '_blank');
    return;
  }

  copyToClipboard(report) {
    let item  = report.Report_Link;
    if(!item) {
      item = this.getReportLinkFromEmbedLink(report); // fallback to get the report link for Power BI
    }
    document.addEventListener('copy', (e: ClipboardEvent) => {
      e.clipboardData.setData('text/plain', item);
      e.preventDefault();
      document.removeEventListener('copy', null);
    });
    document.execCommand('copy');
  }

  //Function to get the report link from the embed link
  getReportLinkFromEmbedLink(report: any): string {
    if(report.Embed_link){
      const parser = new DOMParser();
      const doc = parser.parseFromString(report.Embed_link, 'text/html');
      const iframe = doc.querySelector('iframe');
      if (iframe?.hasAttribute('src')) {
        const src = iframe.getAttribute('src');
        return this.sanitizer.sanitize(SecurityContext.URL, src) || '';
      }
    }
    return '';
  }

  showToolTip(secure_group: any) {
    return 'Request Access to ' + secure_group + ' to view Report';
  }
  showDocumentionInfo(docuMentUrl: any) {
    window.open(docuMentUrl, '_blank');
  }
  getTableClass(type = '') {
    if (this.tableConfig && this.tableConfig.tableClass) {
      if (type) {
        return this.tableConfig.tableClass + '_' + type;
      } else {
        return this.tableConfig.tableClass;
      }
    }
    return '';
  }
  fetchMoreItems(event) {
    if (this.sortConfig) {
      event.sort = [[this.sortConfig.active, this.sortConfig.direction]];

      if (this.searchField) {
        event.search = this.searchField;
      }
    }
    this.paginationClickEvent.emit(event);
    return false;
  }

  sortData(event) {
    if (this.tableConfig.serverSidePagination) {
      let sort: any[] = [];
      if (event.direction) {
        sort = [[event.active, event.direction]];
      }
      this.sortChangeEvent.emit(sort);
    }
  }

  checkToolTip(column) {
    let status = false;
    switch (column.columnDef) {
      case 'Employee_Count':
        status = true;
        break;
    }
    return status;
  }

  getToolTipContent(column) {
    let content: any;
    switch (column.columnDef) {
      case 'Employee_Count':
        content = 'Headcount calculated based on billable utilization';
        break;
    }
    return content;
  }
  checkForHover(column) {
    let hoverStatus = false;
    switch (column) {
      case 'appName3':
        hoverStatus = true;
        this.isExpand = true;
        break;
    }
    return hoverStatus;
  }

  getColumValue(column, ele) {
    if (column == 'appName3') {
      const temp = this.selectedRowIndex;
      if (temp == ele.appName3) {
        this.selectedRowIndex = '';
      } else {
        this.selectedRowIndex = ele.appName3;
      }
      this.isExpand = true;
    } else {
      this.isExpand = false;
    }
  }

  getClassHtmlClassName(column, element) {
    if (column['columnLink']) {
      return '';
    }
    if (
      this.tableConfig &&
      ['lbr_type_tble_class', 'dept_tble_class', 'emp_tble_class'].includes(this.tableConfig['tableClass'])
    ) {
      if (element[column['columnDef']]) {
        return 'link-click';
      }
    } else {
      return 'link-click';
    }
  }

  childSearchCallback(event) {
    const currentSearchedValue = event.target.value;
    if (!this.searchConfig.isServerSideSearch) {
      if (this.searchConfig.validateSearch !== undefined) {
        const validateResult = this.searchConfig.validateSearch(currentSearchedValue);
        if (validateResult) {
          this.dataSource.filter = currentSearchedValue;
        } else {
          this.dataSource.filter = '';
        }
      } else {
        this.dataSource.filter = currentSearchedValue;
      }
    } else {
      this.searchConfig.onServerSearch(currentSearchedValue);
    }
  }
  closeSearch() {
    this.dataSource.filter = '';
  }

  getSelectedRowC() {
    return this.selection.selected;
  }

  getServiceInfo(details) {
    return details.SV_DESC ? `Service Description:${details.SV_DESC}` : '';
  }

  checkFlagCondition(column) {
    if (column.columnDef === 'current') {
      return false;
    }
  
    const padu = this.paduData.lowest_padu;
    
    if (column.columnDef === 'current') {
      return false;
    }

    const transitionNumber = this.getTransitionNumber(column.columnDef);
    if (transitionNumber === null) {
      return false;
    }

    return this.evaluateTransitionCondition(padu, transitionNumber);
  }

  private getTransitionNumber(columnDef: string): number | null {
    const match = columnDef.match(/^transition_(\d+)$/);
    return match ? parseInt(match[1], 10) : null;
  }

  private evaluateTransitionCondition(padu: any, transitionNumber: number): boolean {
    const currentTransition = `transition_${transitionNumber}`;
    const previousTransition = transitionNumber > 1 ? `transition_${transitionNumber - 1}` : 'current';

    return this.checkUpwardTransition(padu, currentTransition, previousTransition) ||
           this.checkDownwardTransition(padu, currentTransition, transitionNumber);
  }

  private checkUpwardTransition(padu: any, currentTransition: string, previousTransition: string): boolean {
    return padu[currentTransition] &&
           padu[previousTransition] === padu[currentTransition] &&
           padu[currentTransition].toLocaleLowerCase() === 'u';
  }

  private checkDownwardTransition(padu: any, currentTransition: string, transitionNumber: number): boolean {
    if (transitionNumber <= 1) {
      return false;
    }

    const downwardConditions = this.getDownwardConditionMap();
    const condition = downwardConditions[transitionNumber];
    
    if (!condition) {
      return false;
    }

    return padu[currentTransition] &&
           this.validateTransitionChain(padu, condition.transitions) &&
           padu[condition.checkTransition].toLocaleLowerCase() === 'd';
  }

  private getDownwardConditionMap(): any {
    return {
      2: {
        transitions: ['current', 'transition_1', 'transition_2'],
        checkTransition: 'transition_2'
      },
      3: {
        transitions: ['transition_1', 'transition_2', 'transition_3'],
        checkTransition: 'transition_2'
      },
      4: {
        transitions: ['transition_2', 'transition_3', 'transition_4'],
        checkTransition: 'transition_4'
      },
      5: {
        transitions: ['transition_3', 'transition_4', 'transition_5'],
        checkTransition: 'transition_5'
      },
      6: {
        transitions: ['transition_4', 'transition_5', 'transition_6'],
        checkTransition: 'transition_6'
      }
    };
  }

  private validateTransitionChain(padu: any, transitions: string[]): boolean {
    for (let i = 0; i < transitions.length - 1; i++) {
      if (padu[transitions[i]] !== padu[transitions[i + 1]]) {
        return false;
      }
    }
    return true;
  }
  getFlagStyle() {
    let style = { color: 'red', 'font-size': '16px' };
    const color = this.paduData.RoadMap_Flag;
    if (color && color != 'Not Flagged') {
      style = { color: color.toLowerCase(), 'font-size': '16px' };
    }
    return style;
  }


  filterDropdownforAssociatedCapabilitiesPopup(column) {
    this.searchValue = '';

    const header = column?.header;
    const noFilters = this.Allfilter.length == 0;
    const config = this.getAssociatedCapabilitiesPopupFilterConfig(header, noFilters);

    if (config) {
      this.filterListR = (config.data || []).map(item => item?.[config.dataProperty]);
      this.filValue = config.filValue;
      const trigger = this.trigger?.toArray?.()[config.triggerIndex];
      if (trigger) trigger.openMenu();
    }

    // Preserve previous behavior: always normalize into a Set for the dropdown list.
    this.filterListR = new Set([...(this.filterListR || [])]);
    this.filterLists = this.filterListR;
  }

  private getAssociatedCapabilitiesPopupFilterConfig(
    header: string,
    noFilters: boolean
  ):
    | { data: any[]; dataProperty: string; filValue: any; triggerIndex: number }
    | null {
    const oldData = this.olddatasource || [];
    const currentData = (this.dataSource && this.dataSource.data) ? this.dataSource.data : [];
    const baseData = noFilters ? oldData : currentData;

    const configs: Record<
      string,
      () => { data: any[]; dataProperty: string; filValue: any; triggerIndex: number } | null
    > = {
      'ApplicationID': () => ({ data: baseData, dataProperty: 'ApplicationID', filValue: this.REPFilter, triggerIndex: 0 }),
      'Application ID': () => ({ data: currentData, dataProperty: 'app_id', filValue: this.REPFilter, triggerIndex: 0 }),
      'ApplicationName': () => ({ data: baseData, dataProperty: 'ApplicationName', filValue: this.DSCFilter, triggerIndex: 1 }),
      'Application Name': () => ({ data: currentData, dataProperty: 'app_name', filValue: this.DSCFilter, triggerIndex: 1 }),
      'Capability PADU': () => ({ data: baseData, dataProperty: 'CapabilityPADU', filValue: this.TYPEFilter, triggerIndex: 2 }),
      'Application PADU': () => ({ data: baseData, dataProperty: 'ApplicationPADU', filValue: this.TYPEFilter, triggerIndex: 2 }),
      'Application Life Cycle': () => ({
        data: currentData,
        dataProperty: 'app_lifecycle_status',
        filValue: this.TYPEFilter,
        triggerIndex: 2
      }),
      'SERVICE': () => ({
        data: baseData,
        dataProperty: 'Service_Description',
        filValue: this.TYPEFilter,
        triggerIndex: this.isInfraTable ? 1 : 0
      }),
      'Billing Group': () => ({
        data: baseData,
        dataProperty: 'Billing_Groups',
        filValue: this.billingGroupsFilter,
        triggerIndex: 0
      }),
      'Category': () => ({
        data: baseData,
        dataProperty: 'CategoryName',
        filValue: this.categoryNameFilter,
        triggerIndex: this.isInfraTable ? 0 : 1
      }),

      // Preserve existing behavior: only supported when no filters are applied.
      'Server': () =>
        noFilters
          ? ({ data: oldData, dataProperty: 'CS_SERVICE_VIRTUAL', filValue: this.TYPEFilter, triggerIndex: 0 })
          : null,
    };

    const build = header ? configs[header] : null;
    return build ? build() : null;
  }

  resetFilters() {
    this.Allfilter.forEach((a, i) => {
      if (a.column == 'Service_Description') this.Allfilter.splice(i, 1);
    });
    this.filterApplied = false;
    this.filterAssetIdApplied = false;
    this.filterAssetNameApplied = false;
    this.filterAssetOwnerApplied = false;
    this.filterAssetTeamApplied = false;
    this.filterApplicationIdApplied = false;
    this.filterApplicationNameApplied = false;
    this.filterApplicationPADUApplied = false;
    this.filterApplicationLifeCycleApplied = false;
  }

  checkServiceFlagCondition(element) {
    if (
      element.flagapp &&
      element.flagapp.length > 0 &&
      !(element.flagapp[0].flag == 0 && element.flagapp[0].Flag_Email == 0)
    ) {
      return true;
    } else {
      return false;
    }
  }

  getServiceFlagStyle(element) {
    let color = 'red';
    if (element.flagapp[0].flag == 1 && element.flagapp[0].Flag_Email == 1) {
      color = 'red';
    } else if (element.flagapp[0].flag == 1 && element.flagapp[0].Flag_Email == 0) {
      color = 'orange';
    }
    const style = { color: color, 'font-size': '16px;', 'vertical-align': 'bottom', 'margin-right': '0.23vw' };
    return style;
  }

  reportHasLoggedInUserOwner(ownerDetails: any, HasOwner: any) {
    const loggedInUserMSID = this.sharedAuthService.getMsid();
    if (ownerDetails != null) {
      const owners = ownerDetails.split(',').map(x => x.trim());
      const reportOwnerIsloggedinUser = owners.includes(loggedInUserMSID);
      if (reportOwnerIsloggedinUser && HasOwner == 'Yes') {
        return true;
      } else return false;
    } else return false;
  }

  editReport(id, Report, Description, Report_Link) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      id: id,
      Report: Report,
      Description: Description,
      Report_Link: Report_Link
    };
    dialogConfig.width = '50%';
    dialogConfig.hasBackdrop = false;
    dialogConfig.panelClass = 'custom-modalbox';
    dialogConfig.height = '62%';
    dialogConfig.disableClose = false;
    dialogConfig.maxWidth = '80vw';
    dialogConfig.position = { right: '340px', top: '140px' };

    const dialogRef = this.dialog.open(EditReportComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result.anyChangeInData) {
        this.datarefresh.emit(true);
      }
    });
  }

  checkPrevious(event,prevArr:any = []) {
    this.previousSelection = prevArr;
    const filterList:Array<any> = [...this.filterLists];
    if (this.previousSelection && this.previousSelection.length > 0) {
      let isPrevValueUnselected = true;
      for (let i = 0; i < this.previousSelection.length; i++) {
        //If previous selection is in DropDownData and not in event then only add previous selection in Event Values(Server Side Search)
        const uncheckedElementName = event.options[0]._value;
        const unchekcedStatus = event.options[0]._selected;
        if (!(unchekcedStatus) && isPrevValueUnselected) { //check for unchecked elements
          if (this.previousSelection[i] == uncheckedElementName) //check for element which is unchecked
          {
            this.previousSelection.splice(i, 1);
            i--;
            isPrevValueUnselected = false;
          }
        } else if (filterList.includes(this.previousSelection[i]) && event.source._value.length > 0
          && !event.source._value.includes(this.previousSelection[i]))  //Checked cond1
        {
          event.source._value.push(this.previousSelection[i]);
        }
      }
    }
    if (event.source._value.length == 0) {//Unchecked cond2: element is unchecked after search
      for (let i = 0; i < this.previousSelection.length; i++) {
        if (filterList.includes(this.previousSelection[i])) {
          event.source._value.push(this.previousSelection[i]);
        }
      }
    }
    this.previousSelection = [... new Set(event.source._value)];
    return event
  }
  
  getScrollData(el,col){
    if(col.columnDef == 'users'){
      return el[col.columnDef].sort((a,b)=>a[col.key].localeCompare(b[col.key]));
    }else if(col.columnDef == 'aliases'){
      const aliasData = el[col.columnDef] ? el[col.columnDef].split(',') : [];
      return aliasData.sort((a,b)=>a.localeCompare(b));
    }else{
      return [];
    }
  }

  editRecord(element) {
    this.editRecordEvent.emit(element);
  }

  updatePrimaryStatus(element) {
    this.updatePrimaryStatusEvent.emit(element);
  }

  //Downloading BLOB data
  downloadFile(element){
    const url = this.sanitizer.sanitize(SecurityContext.URL, element.url);
    if(url){
        const a = document.createElement('a');
        a.href = url;
        a.download = 'LargeExtract.txt';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }
  }

  //Function to open App hub page
  linkToApplicationPage(ele,col){
    const data = {
      el: ele,
      col: col
    }
    this.onApplicationLinkClicked.emit(data);
  }
}
